import { XIcon } from '../../shared/icons';
import './search.css';

interface Props extends Omit<
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'type'
> {
    onClear?: () => void;
    leading?: React.ReactNode;
}

export default function Search({ placeholder, value, onClear, leading, ...props }: Props) {
    return (
        <div className='relative search'>
            {leading}
            <input type='text' value={value} {...props} placeholder={placeholder ?? 'Search...'} />
            {value !== '' && (
                <button type='button' className='absolute right-3' onClick={onClear}>
                    <XIcon size={40} />
                </button>
            )}
        </div>
    );
}
